// @ts-strict-ignore
import clsx from 'clsx'
import { FC } from 'react'

import { HeaderSearch } from '@/widgets/Header/ui/header-search/header-search'

import { OffCanvasPopupWithOpenClose as BurgerMenu } from './header-burger/header-burger'
import { HeaderCategoriesLinks } from './header-categories-links/header-categories-links'
import { HeaderCategories } from './header-categories/header-categories'
import { HeaderLogo } from './header-logo/header-logo'
import { HeaderPersonalLinks } from './header-personal-links/header-personal-links'

import cl from './style.module.scss'

export const Header: FC = () => {
	return (
		<header className={clsx(cl.header, 'js-header')}>
			<div className={cl.container}>
				<div className={cl.body}>
					<div className={cl.logoWrapper}>
						<BurgerMenu />
						<HeaderLogo />
					</div>
					<div className={cl.links}>
						{/* Только на мобилке*/}
						<HeaderSearch />
						<HeaderCategoriesLinks />
						<HeaderPersonalLinks />
					</div>
				</div>
				<HeaderCategories />
			</div>
		</header>
	)
}
